"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var overflow_menu_1 = __importDefault(require("@paprika/overflow-menu"));
var popover_1 = __importDefault(require("@paprika/popover"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var NavigationIcon_1 = __importDefault(require("../NavigationIcon/NavigationIcon"));
var constants_1 = require("../../constants");
var GlobalNavigation_styles_1 = require("../../GlobalNavigation.styles");
var HelperWithPendo_styles_1 = __importDefault(require("./HelperWithPendo.styles"));
require("./HelperWithPendo.scss");
function HelperWithPendo(_a) {
    var helpDocUrl = _a.helpDocUrl, supportUrl = _a.supportUrl, zIndex = _a.zIndex;
    var _b = react_1.default.useState(false), isOverflowMenuOpen = _b[0], setIsOverflowMenuOpen = _b[1];
    var _c = react_1.default.useState(false), isTooltipOpen = _c[0], setIsTooltipOpen = _c[1];
    var _d = react_1.default.useState(false), isKeyboardInput = _d[0], setIsKeyboardInput = _d[1];
    var i18n = useI18n_1.default();
    function handleCloseOverflowMenu() {
        setIsOverflowMenuOpen(false);
    }
    function isGovCloud() {
        return window.location.href.indexOf('highbond-gov') > -1;
    }
    function toggleIsOpen(event) {
        setIsKeyboardInput(!!event.key && (event.key === ' ' || event.key === 'Enter'));
        setIsOverflowMenuOpen(function (prevIsOpen) { return !prevIsOpen; });
        if (!isOverflowMenuOpen) {
            setIsTooltipOpen(false);
        }
    }
    function handleTooltipOpen() {
        if (!isOverflowMenuOpen) {
            setIsTooltipOpen(true);
        }
    }
    function handleTooltipClose() {
        setIsTooltipOpen(false);
    }
    var isOpenValue = isOverflowMenuOpen && (isGovCloud() || isKeyboardInput);
    return (react_1.default.createElement(HelperWithPendo_styles_1.default, { className: !isGovCloud() ? 'navigation-helper--with-pendo' : '', "data-sri-anchor": "navigation-helper" },
        react_1.default.createElement(popover_1.default, { isEager: true, isDark: true, isOpen: isTooltipOpen, zIndex: zIndex },
            react_1.default.createElement(popover_1.default.Trigger, null, function () { return (react_1.default.createElement("span", { onMouseOver: handleTooltipOpen, onMouseOut: handleTooltipClose, onFocus: handleTooltipOpen, onBlur: handleTooltipClose },
                react_1.default.createElement(overflow_menu_1.default, { onClose: handleCloseOverflowMenu, zIndex: zIndex, isOpen: isOpenValue },
                    react_1.default.createElement(overflow_menu_1.default.Trigger, { "data-sri-anchor": "navigation-item.trigger", a11yText: i18n.t('global_navigation.navigation_items.helper'), isOpen: isOpenValue, onClick: toggleIsOpen, menuRefId: "global-navigation-helper__overflow-content" },
                        react_1.default.createElement(NavigationIcon_1.default, { icon: constants_1.icons.helper })),
                    react_1.default.createElement(overflow_menu_1.default.Content, { id: "global-navigation-helper__overflow-content", className: "sriracha" }),
                    react_1.default.createElement(GlobalNavigation_styles_1.OverflowMenuLinkItem, { "data-sri-anchor": "navigation-overflow.link", isExternal: true, link: helpDocUrl }, i18n.t('global_navigation.helper.help_docs')),
                    react_1.default.createElement(GlobalNavigation_styles_1.OverflowMenuLinkItem, { "data-sri-anchor": "navigation-overflow.link", isExternal: true, link: supportUrl }, i18n.t('global_navigation.helper.support'))))); }),
            react_1.default.createElement(popover_1.default.Content, null,
                react_1.default.createElement(popover_1.default.Card, null, i18n.t('global_navigation.navigation_items.helper'))),
            react_1.default.createElement(popover_1.default.Tip, null))));
}
HelperWithPendo.propTypes = {
    helpDocUrl: prop_types_1.default.string.isRequired,
    supportUrl: prop_types_1.default.string.isRequired,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
HelperWithPendo.defaultProps = {
    zIndex: null,
};
HelperWithPendo.componentType = constants_1.navigationItems.helperWithPendo;
exports.default = HelperWithPendo;
//# sourceMappingURL=HelperWithPendo.js.map